// extracted by mini-css-extract-plugin
export default {"card":"ToolsCard_card__eZ+cL","label":"ToolsCard_label__pvxLJ"};